module.exports = __webpack_public_path__ + "static/media/brain mock.06c5bc99.png";